
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import rules from "@/store/rules";

@Component
export default class NewMaterialDialog extends Vue {
	@Prop()
	private open!: boolean;
	@Prop()
	private werkstoffName!: string;
	@Prop()
	private materials!: [];
	private valid: boolean = true;
	private selectedBaseMaterialId: number = 0;
	private newMaterialName: string = "";
	private newMaterialThickness: number = 0.0;
	private materialNameRule = [
		(v: string) => !!v || "Angabe erforderlich",
		(v: string) =>
			v.replace(/\s/g, "").length > 0 || "Eingabe darf nicht nur Leerzeichen sein.",
		(v: string) => !v || v.length <= 50 || "Maximal 50 Zeichen erlaubt.",
		(v: string) => !v || this.isNoDuplicate(v) || "Material mit diesem Namen existiert bereits",
	];
	private requiredNumberBiggerZeroRule = rules.requiredNumberBiggerZeroRule;
	private baseMaterialRule = [
		(v: number) => !!v || "Basismaterial muss ausgewählt werden",
		(v: number) => !v || v > 0 || "Basismaterial muss ausgewählt werden",
	];

	private mounted() {
		(this.$refs.form as any).validate();
	}

	private setMaterialName() {
		let material = this.materials.filter((m: any) => m.id === this.selectedBaseMaterialId)[0];
		this.newMaterialName = material["name"];
	}

	private isNoDuplicate(materialName: string): boolean {
		return !this.materials.some((m: any) => m.name === materialName);
	}

	private createMaterial() {
		let data = {
			baseMaterialId: this.selectedBaseMaterialId,
			baseWerkstoffName: this.werkstoffName,
			materialBeschreibung: this.newMaterialName,
			thickness: this.newMaterialThickness,
			compareMaterialId: 0,
		};
		this.$emit("create", data);
	}

	private close() {
		this.$emit("close");
	}
}
